import { gql } from "lib/apolloClient";
import { organizationFragment } from "./RubricFragments";

export const getOrganizationRubricsQuery = gql`
  query getOrganizationRubrics($id: ID!, $filters: AssessmentToolFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationItem
      }
    }
  }
  ${organizationFragment.rubricList}
`;
